import "./AboutUs.scss";
import Btn from "../../../components/btn/Btn";
import { motion } from "framer-motion";
import { baseUrl } from "../../../utils/apiData";
import { paths } from "../../../utils/paths";
import { useNavigate } from "react-router-dom";
import { Fragment } from "react";

const AboutUs = ({
  tagTitle,
  title,
  des,
  img,
  contentLeft,
  btnName,
  classList,
}) => {
  const navigate = useNavigate();

  const content = (
    <div className="left">
      {tagTitle && (
        <motion.p
          initial={{ translateX: 32, opacity: 0 }}
          whileInView={{ translateX: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          viewport={{ once: true }}
          className="tag_title"
        >
          <span>_</span>
          {tagTitle}
        </motion.p>
      )}
      {title && (
        <motion.h2
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeInOut", delay: 0.15 }}
          viewport={{ once: true }}
        >
          {title}
        </motion.h2>
      )}

      <div className="des" dangerouslySetInnerHTML={{ __html: des }} />

      {btnName && (
        <Btn title={btnName} onClick={() => navigate(paths.CONTACT)} />
      )}
    </div>
  );

  const imgSec = (
    <div className="img_wraper">
      <motion.img
        initial={{ translateY: 32, opacity: 0 }}
        whileInView={{ translateY: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        viewport={{ once: true }}
        src={`${baseUrl}/${img}`}
        alt="About Us"
      />
    </div>
  );

  return (
    <section className={`about_us ${classList}`}>
      <div className="content_wrap">
        <div className="bi_grid">
          {contentLeft ? (
            <Fragment>
              {content}
              {imgSec}
            </Fragment>
          ) : (
            <Fragment>
              {imgSec}
              {content}
            </Fragment>
          )}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
